import sessionReducer from '@/features/session/sessionSlice';
import softTagReducer from '@/features/softTag/softTagSlice';
import coreReducer from './coreSlice';
const rootReducer = {
  reducer: {
    core: coreReducer,
    session: sessionReducer,
    softTag: softTagReducer,
  },
};

export default rootReducer;
